import { useGetIdentity, useListFilterContext, useTranslate } from "ra-core";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

export const OnlyMineInput = ({
  label = "resources.deals.filters.only_mine",
}: {
  alwaysOn: boolean;
  source: string;
  /** i18n key for the switch label. Defaults to the deals key so DealList keeps working. */
  label?: string;
}) => {
  const translate = useTranslate();
  const { filterValues, displayedFilters, setFilters } = useListFilterContext();
  const { identity } = useGetIdentity();

  const handleChange = () => {
    const newFilterValues = { ...filterValues };
    if (typeof filterValues.sales_id !== "undefined") {
      delete newFilterValues.sales_id;
    } else {
      newFilterValues.sales_id = identity && identity?.id;
    }
    setFilters(newFilterValues, displayedFilters);
  };
  return (
    <div className="mt-auto pb-2.25">
      <div className="flex items-center space-x-2">
        <Switch
          id="only-mine"
          checked={typeof filterValues.sales_id !== "undefined"}
          onCheckedChange={handleChange}
        />
        <Label htmlFor="only-mine">
          {translate(label, { _: "Only deals I manage" })}
        </Label>
      </div>
    </div>
  );
};
